export default __webpack_public_path__ + "static/media/modal04.66daae8b.png";